export const categoryInfo: Record<string, {
  name: string;
  slug: string;
  icon: string;
  description: string;
  count: number;
  image: string;
}> = {
  "star-gossip": {
    name: "明星爆料",
    slug: "star-gossip",
    icon: "ri-star-line",
    description: "最新鲜的明星八卦、恋情曝光、离婚内幕，第一时间为你揭开娱乐圈的神秘面纱。",
    count: 1280,
    image: "https://readdy.ai/api/search-image?query=Red%20carpet%20event%20with%20camera%20flashes%2C%20celebrity%20silhouettes%2C%20glamorous%20Hollywood%20atmosphere%2C%20dramatic%20spotlight%20beams%2C%20golden%20and%20warm%20tones%2C%20paparazzi%20style%2C%20elegant%20evening%20scene%2C%20high%20contrast%20lighting%2C%20luxurious%20venue&width=1600&height=500&seq=category-star-gossip&orientation=landscape",
  },
  "influencer-gossip": {
    name: "网红黑料",
    slug: "influencer-gossip",
    icon: "ri-live-line",
    description: "网红圈的风吹草动都在这里，直播翻车、人设崩塌、带货争议一网打尽。",
    count: 960,
    image: "https://readdy.ai/api/search-image?query=Modern%20social%20media%20influencer%20studio%20setup%20with%20ring%20light%20and%20smartphone%20tripod%2C%20colorful%20LED%20background%2C%20content%20creation%20workspace%2C%20vibrant%20neon%20aesthetic%2C%20digital%20creator%20atmosphere%2C%20trendy%20vibe&width=1600&height=500&seq=category-influencer&orientation=landscape",
  },
  "show-gossip": {
    name: "综艺爆料",
    slug: "show-gossip",
    icon: "ri-tv-line",
    description: "热门综艺幕后故事、嘉宾冲突、选秀黑幕，镜头之外的精彩比正片还好看。",
    count: 756,
    image: "https://readdy.ai/api/search-image?query=Television%20studio%20production%20set%20with%20professional%20cameras%20and%20lighting%20rigs%2C%20reality%20show%20stage%2C%20dramatic%20spotlighting%2C%20behind%20the%20scenes%20atmosphere%2C%20broadcast%20equipment%2C%20warm%20studio%20tones%2C%20creative%20production%20environment&width=1600&height=500&seq=category-show&orientation=landscape",
  },
  "industry-insider": {
    name: "娱乐圈内幕",
    slug: "industry-insider",
    icon: "ri-spy-line",
    description: "深度揭秘娱乐圈潜规则、行业黑幕、资本博弈，让你看清娱乐圈的真实面目。",
    count: 632,
    image: "https://readdy.ai/api/search-image?query=Mysterious%20backstage%20corridor%20with%20dim%20lighting%2C%20film%20industry%20setting%2C%20closed%20doors%20with%20nameplates%2C%20dramatic%20shadows%2C%20Hollywood%20insider%20atmosphere%2C%20confidential%20mood%2C%20warm%20tungsten%20light%2C%20cinematic%20composition&width=1600&height=500&seq=category-insider&orientation=landscape",
  },
  "idol-group": {
    name: "偶像团体",
    slug: "idol-group",
    icon: "ri-group-line",
    description: "偶像团体的内部关系、成员不和、解散风波，粉丝圈最关心的都在这儿。",
    count: 518,
    image: "https://readdy.ai/api/search-image?query=K-pop%20style%20group%20performance%20stage%20with%20colorful%20laser%20lights%2C%20concert%20atmosphere%2C%20energetic%20vibe%2C%20synchronized%20dance%20formation%20silhouettes%2C%20massive%20LED%20screen%20background%2C%20fan%20lightsticks%20ocean%2C%20entertainment%20spectacle&width=1600&height=500&seq=category-idol&orientation=landscape",
  },
  "esports-gossip": {
    name: "电竞八卦",
    slug: "esports-gossip",
    icon: "ri-gamepad-line",
    description: "电竞圈转会爆料、选手私生活、战队内讧，游戏之外的瓜也又大又甜。",
    count: 445,
    image: "https://readdy.ai/api/search-image?query=Professional%20esports%20gaming%20arena%20with%20RGB%20lighting%2C%20competitive%20gaming%20setup%2C%20championship%20stage%2C%20dramatic%20blue%20and%20pink%20neon%20atmosphere%2C%20gaming%20monitors%20and%20keyboards%2C%20spectator%20crowd%20energy%2C%20futuristic%20venue&width=1600&height=500&seq=category-esports&orientation=landscape",
  },
};

export const categoryArticles: Record<string, Array<{
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  date: string;
  views: number;
  isNew?: boolean;
  isHot?: boolean;
}>> = {
  "star-gossip": [
    {
      slug: "top-star-secret-romance-exposed",
      title: "顶流明星深夜密会曝光，知情人士爆料已秘密交往一年",
      excerpt: "据知情人士透露，两位一线明星已秘密交往超过一年，多次被拍到深夜密会。",
      image: "https://readdy.ai/api/search-image?query=Evening%20urban%20scene%20with%20two%20silhouettes%20walking%20in%20dim%20street%20light%2C%20mysterious%20atmosphere%2C%20paparazzi%20style%20photography%2C%20blurred%20background%20with%20city%20lights%2C%20warm%20evening%20tones%2C%20dramatic%20lighting%2C%20soft%20focus%2C%20candid%20moment%20captured&width=800&height=600&seq=cat-star-01&orientation=landscape",
      date: "2026-06-28",
      views: 128000,
      isNew: true,
      isHot: true,
    },
    {
      slug: "actress-divorce-details",
      title: "知名女星被曝已协议离婚，财产分割细节意外流出",
      excerpt: "结婚仅三年的知名女星被曝已与丈夫协议离婚，涉及数亿资产分割。",
      image: "https://readdy.ai/api/search-image?query=Elegant%20woman%20silhouette%20walking%20alone%20on%20city%20street%20at%20sunset%2C%20reflective%20mood%2C%20luxury%20handbag%2C%20dramatic%20backlighting%2C%20golden%20hour%20tones%2C%20fashion%20editorial%20style%2C%20melancholic%20atmosphere%2C%20soft%20bokeh%20background&width=800&height=600&seq=cat-star-02&orientation=landscape",
      date: "2026-06-25",
      views: 112000,
      isHot: true,
    },
    {
      slug: "endorsement-scandal",
      title: "大牌明星代言涉嫌虚假宣传，消费者集体维权",
      excerpt: "某一线明星代言的品牌被曝涉嫌虚假宣传，多位消费者已联合发起维权诉讼。",
      image: "https://readdy.ai/api/search-image?query=Luxury%20beauty%20product%20display%20on%20marble%20counter%2C%20elegant%20packaging%2C%20soft%20studio%20lighting%2C%20cosmetic%20product%20photography%2C%20cream%20and%20gold%20tones%2C%20sophisticated%20aesthetic%2C%20editorial%20style&width=800&height=600&seq=cat-star-03&orientation=landscape",
      date: "2026-06-24",
      views: 132000,
    },
    {
      slug: "plastic-surgery-leak",
      title: "女星整容前后对比照意外流出，本人回应引热议",
      excerpt: "一组疑似某知名女星整容前后对比照在网络上疯传，引发网友热议。",
      image: "https://readdy.ai/api/search-image?query=Beauty%20clinic%20interior%20with%20soft%20pink%20and%20white%20tones%2C%20modern%20minimalist%20aesthetic%2C%20clean%20medical%20setting%2C%20diffused%20natural%20lighting%2C%20elegant%20atmosphere%2C%20spa-like%20environment%2C%20professional%20beauty%20treatment%20room&width=800&height=600&seq=cat-star-04&orientation=landscape",
      date: "2026-06-23",
      views: 105000,
    },
    {
      slug: "star-tax-scandal",
      title: "又一位明星涉税问题被查，补缴金额或过亿",
      excerpt: "继多位明星被曝税务问题后，又一位当红艺人被税务机关约谈调查。",
      image: "https://readdy.ai/api/search-image?query=Serious%20financial%20documents%20and%20calculator%20on%20dark%20wooden%20desk%2C%20dramatic%20side%20lighting%2C%20professional%20office%20setting%2C%20formal%20atmosphere%2C%20tax%20investigation%20theme%2C%20warm%20amber%20desk%20lamp%20glow%2C%20intense%20mood&width=800&height=600&seq=cat-star-05&orientation=landscape",
      date: "2026-06-22",
      views: 156000,
      isHot: true,
    },
    {
      slug: "celebrity-feud-exposed",
      title: "两位大花旦十年恩怨曝光，起因竟是一部戏的角色之争",
      excerpt: "娱乐圈两位顶级女星长达十年的恩怨情仇被知情人士详细曝光。",
      image: "https://readdy.ai/api/search-image?query=Two%20elegant%20chairs%20facing%20opposite%20directions%20on%20theater%20stage%2C%20dramatic%20spotlight%2C%20tense%20artistic%20atmosphere%2C%20red%20velvet%20curtains%2C%20theatrical%20drama%20aesthetic%2C%20symbolic%20composition%2C%20high%20contrast%20lighting&width=800&height=600&seq=cat-star-06&orientation=landscape",
      date: "2026-06-21",
      views: 89000,
    },
  ],
  "influencer-gossip": [
    {
      slug: "internet-celebrity-scandal-live",
      title: "某千万粉丝网红直播翻车，黑历史被扒引发全网热议",
      excerpt: "知名网红在直播中被网友扒出早年黑历史，直播间弹幕瞬间炸锅。",
      image: "https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20live%20streaming%20interface%20with%20chat%20comments%2C%20dramatic%20red%20and%20dark%20lighting%2C%20social%20media%20drama%20aesthetic%2C%20digital%20screen%20glow%2C%20tense%20atmosphere%2C%20modern%20streaming%20setup%2C%20intense%20mood&width=800&height=600&seq=cat-inf-01&orientation=landscape",
      date: "2026-06-27",
      views: 96000,
      isNew: true,
    },
    {
      slug: "tax-evasion-case",
      title: "知名主播涉嫌偷税漏税被查，金额或达千万",
      excerpt: "某平台头部带货主播被税务部门立案调查，涉嫌偷逃税款数额巨大。",
      image: "https://readdy.ai/api/search-image?query=Serious%20legal%20documents%20on%20wooden%20desk%2C%20gavel%20in%20background%2C%20dramatic%20side%20lighting%2C%20professional%20law%20office%20atmosphere%2C%20dark%20wood%20tones%2C%20formal%20and%20weighty%20mood%2C%20editorial%20photography&width=800&height=600&seq=cat-inf-02&orientation=landscape",
      date: "2026-06-20",
      views: 98000,
      isHot: true,
    },
    {
      slug: "influencer-fake-products",
      title: "网红带货假货风波再起，消费者买到山寨货要求赔偿",
      excerpt: "一位百万粉丝美妆博主被曝带货山寨化妆品，引发消费者集体维权。",
      image: "https://readdy.ai/api/search-image?query=Counterfeit%20cosmetics%20display%20on%20table%2C%20comparison%20between%20real%20and%20fake%20products%2C%20investigative%20journalism%20style%2C%20bright%20product%20photography%20lighting%2C%20consumer%20protection%20theme%2C%20clean%20white%20background%2C%20detailed%20close-up&width=800&height=600&seq=cat-inf-03&orientation=landscape",
      date: "2026-06-19",
      views: 76000,
    },
    {
      slug: "streamer-contract-dispute",
      title: "头部主播与平台合约纠纷升级，天价违约金曝光",
      excerpt: "某平台一哥因合约问题与平台对簿公堂，违约金数额令人咋舌。",
      image: "https://readdy.ai/api/search-image?query=Business%20contract%20documents%20with%20pen%20on%20glass%20desk%2C%20modern%20corporate%20office%20background%2C%20dramatic%20lighting%20from%20window%2C%20legal%20dispute%20atmosphere%2C%20sleek%20professional%20setting%2C%20tension%20in%20composition&width=800&height=600&seq=cat-inf-04&orientation=landscape",
      date: "2026-06-18",
      views: 65000,
    },
    {
      slug: "influencer-prank-gone-wrong",
      title: "网红恶搞路人翻车遭全网抵制，账号已被平台封禁",
      excerpt: "某搞笑博主因恶意整蛊路人引发众怒，多个平台相继封禁其账号。",
      image: "https://readdy.ai/api/search-image?query=Smartphone%20showing%20account%20suspended%20notification%20screen%2C%20dark%20moody%20lighting%2C%20social%20media%20drama%20concept%2C%20red%20warning%20aesthetic%2C%20digital%20culture%20critique%2C%20close-up%20shot%2C%20dramatic%20atmosphere&width=800&height=600&seq=cat-inf-05&orientation=landscape",
      date: "2026-06-17",
      views: 82000,
      isHot: true,
    },
    {
      slug: "beauty-blogger-surgery-exposed",
      title: "美妆博主素颜直播意外露馅，整容前后落差引争议",
      excerpt: "一位以天然美女著称的美妆博主在素颜直播中露出破绽，粉丝大呼被骗。",
      image: "https://readdy.ai/api/search-image?query=Beauty%20mirror%20with%20skincare%20products%20on%20vanity%20table%2C%20soft%20morning%20light%20through%20window%2C%20personal%20beauty%20routine%20setting%2C%20warm%20feminine%20aesthetic%2C%20natural%20makeup%20theme%2C%20intimate%20atmosphere%2C%20clean%20elegant%20composition&width=800&height=600&seq=cat-inf-06&orientation=landscape",
      date: "2026-06-16",
      views: 71000,
    },
  ],
  "show-gossip": [
    {
      slug: "variety-show-controversy",
      title: "热门综艺录制现场冲突，两位嘉宾因一句玩笑话当场翻脸",
      excerpt: "综艺节目录制中两位嘉宾因玩笑话产生误会，现场气氛一度十分尴尬。",
      image: "https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20bright%20stage%20lights%20and%20empty%20audience%20seats%2C%20two%20chairs%20facing%20each%20other%20on%20stage%2C%20dramatic%20spotlight%20effect%2C%20reality%20show%20aesthetic%2C%20tension%20in%20the%20air%2C%20professional%20studio%20lighting%2C%20behind%20the%20scenes%20vibe&width=800&height=600&seq=cat-show-01&orientation=landscape",
      date: "2026-06-26",
      views: 85000,
      isNew: true,
    },
    {
      slug: "show-controversy",
      title: "选秀节目黑幕被前工作人员曝光，官方紧急回应",
      excerpt: "一位自称曾在某选秀节目工作的人员爆料节目存在严重暗箱操作。",
      image: "https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20spotlight%20and%20microphone%20stand%2C%20empty%20auditorium%2C%20dramatic%20beam%20of%20light%20from%20above%2C%20competition%20atmosphere%2C%20dark%20surroundings%2C%20theatrical%20mood%2C%20behind%20the%20scenes&width=800&height=600&seq=cat-show-02&orientation=landscape",
      date: "2026-06-19",
      views: 118000,
      isHot: true,
    },
    {
      slug: "reality-show-romance-fake",
      title: "恋综嘉宾被曝有男友仍参加节目，节目组回应引更大争议",
      excerpt: "某恋爱综艺女嘉宾被网友扒出已有稳定男友，节目真实性受到质疑。",
      image: "https://readdy.ai/api/search-image?query=Romantic%20dating%20show%20set%20with%20heart%20decorations%20and%20soft%20pink%20lighting%2C%20empty%20couple%20seats%2C%20reality%20TV%20aesthetic%2C%20love%20theme%20backdrop%2C%20warm%20intimate%20atmosphere%2C%20television%20production%20design&width=800&height=600&seq=cat-show-03&orientation=landscape",
      date: "2026-06-18",
      views: 93000,
      isHot: true,
    },
    {
      slug: "singing-competition-rigged",
      title: "知名音乐节目被质疑结果造假，投票数据异常引关注",
      excerpt: "观众发现某音乐竞技节目投票数据存在明显异常，质疑比赛公正性。",
      image: "https://readdy.ai/api/search-image?query=Music%20competition%20stage%20with%20grand%20piano%20under%20spotlight%2C%20empty%20judges%20table%2C%20dramatic%20concert%20hall%20atmosphere%2C%20professional%20audio%20equipment%2C%20theatrical%20lighting%2C%20tension%20and%20drama%20in%20empty%20venue&width=800&height=600&seq=cat-show-04&orientation=landscape",
      date: "2026-06-17",
      views: 67000,
    },
    {
      slug: "talk-show-host-quit",
      title: "王牌脱口秀主持人突然宣布退出，背后原因令人唏嘘",
      excerpt: "一档热播十年的王牌脱口秀节目主持人毫无征兆地宣布离开。",
      image: "https://readdy.ai/api/search-image?query=Empty%20talk%20show%20set%20with%20iconic%20host%20chair%20and%20desk%2C%20nostalgic%20television%20studio%20atmosphere%2C%20warm%20spotlight%20on%20empty%20seat%2C%20broadcast%20camera%20in%20background%2C%20sentimental%20mood%2C%20end%20of%20an%20era%20feeling&width=800&height=600&seq=cat-show-05&orientation=landscape",
      date: "2026-06-16",
      views: 145000,
      isHot: true,
    },
  ],
  "industry-insider": [
    {
      slug: "director-reported",
      title: "知名导演被多人实名举报，行业震动",
      excerpt: "多位圈内人士联合实名举报某知名导演，引发娱乐圈大地震。",
      image: "https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20empty%20movie%20set%2C%20dramatic%20single%20spotlight%2C%20tense%20atmosphere%2C%20professional%20cinema%20equipment%2C%20dark%20studio%20background%2C%20serious%20mood%2C%20behind%20the%20scenes%2C%20cinematic%20lighting&width=800&height=600&seq=cat-ind-01&orientation=landscape",
      date: "2026-06-22",
      views: 198000,
      isHot: true,
    },
    {
      slug: "casting-couch-whistleblower",
      title: "前经纪公司员工曝行业潜规则，新人演员遭遇触目惊心",
      excerpt: "一位曾在大型经纪公司工作多年的业内人士揭露了娱乐圈选角潜规则。",
      image: "https://readdy.ai/api/search-image?query=Shadowy%20film%20casting%20room%20with%20single%20chair%20under%20harsh%20light%2C%20dramatic%20noir%20aesthetic%2C%20film%20industry%20behind%20the%20scenes%2C%20tense%20atmosphere%2C%20professional%20but%20intimidating%20setting%2C%20cinematic%20composition&width=800&height=600&seq=cat-ind-02&orientation=landscape",
      date: "2026-06-20",
      views: 167000,
      isNew: true,
      isHot: true,
    },
    {
      slug: "talent-agency-monopoly",
      title: "头部经纪公司垄断市场，小艺人签约如同卖身契",
      excerpt: "调查报道揭露大型经纪公司利用行业优势压榨新人，合同条款极其苛刻。",
      image: "https://readdy.ai/api/search-image?query=Corporate%20office%20with%20imposing%20glass%20building%20facade%2C%20power%20dynamics%20theme%2C%20dramatic%20sky%20reflection%2C%20business%20dominance%20aesthetic%2C%20cold%20modern%20architecture%2C%20serious%20investigative%20mood%2C%20professional%20photography&width=800&height=600&seq=cat-ind-03&orientation=landscape",
      date: "2026-06-18",
      views: 89000,
    },
    {
      slug: "box-office-fraud",
      title: "电影票房造假内幕曝光，多家影院参与注水操作",
      excerpt: "业内爆料称部分电影票房存在严重注水现象，午夜幽灵场屡禁不止。",
      image: "https://readdy.ai/api/search-image?query=Empty%20cinema%20auditorium%20with%20ghostly%20blue%20screen%20glow%2C%20abandoned%20theater%20atmosphere%2C%20movie%20ticket%20counter%20with%20dramatic%20shadows%2C%20eerie%20quiet%20mood%2C%20film%20industry%20critique%2C%20haunting%20composition&width=800&height=600&seq=cat-ind-04&orientation=landscape",
      date: "2026-06-15",
      views: 72000,
    },
    {
      slug: "pr-team-secret-weapon",
      title: "顶级公关团队内部手册曝光，明星危机处理有固定套路",
      excerpt: "一份据称来自某知名公关公司的内部培训手册在圈内流传。",
      image: "https://readdy.ai/api/search-image?query=PR%20crisis%20management%20war%20room%20with%20multiple%20screens%20showing%20social%20media%20feeds%2C%20intense%20professional%20atmosphere%2C%20modern%20communication%20agency%20setting%2C%20dramatic%20blue%20monitor%20glow%2C%20strategic%20planning%20mood&width=800&height=600&seq=cat-ind-05&orientation=landscape",
      date: "2026-06-14",
      views: 95000,
      isHot: true,
    },
  ],
  "idol-group": [
    {
      slug: "group-conflict",
      title: "某偶像组合成员内部不和曝光，粉丝站纷纷关站",
      excerpt: "一支当红偶像团体被曝成员之间存在严重矛盾，多个大站宣布关闭。",
      image: "https://readdy.ai/api/search-image?query=K-pop%20style%20dance%20practice%20room%20with%20mirrored%20walls%2C%20empty%20and%20quiet%2C%20dim%20lighting%2C%20melancholic%20mood%2C%20professional%20dance%20studio%2C%20wooden%20floor%2C%20abandoned%20atmosphere%2C%20emotional&width=800&height=600&seq=cat-idol-01&orientation=landscape",
      date: "2026-06-21",
      views: 167000,
      isHot: true,
    },
    {
      slug: "boy-band-disband-rumor",
      title: "出道五年男团传解散，成员各自成立工作室引猜测",
      excerpt: "某知名男子组合多名成员近期相继成立个人工作室，解散传闻甚嚣尘上。",
      image: "https://readdy.ai/api/search-image?query=Empty%20concert%20stage%20with%20scattered%20instrument%20cases%2C%20end%20of%20show%20atmosphere%2C%20melancholic%20blue%20lighting%2C%20band%20breakup%20theme%2C%20emotional%20farewell%20mood%2C%20music%20industry%2C%20artistic%20composition&width=800&height=600&seq=cat-idol-02&orientation=landscape",
      date: "2026-06-19",
      views: 134000,
      isHot: true,
    },
    {
      slug: "trainee-abuse-allegations",
      title: "娱乐公司被曝虐待练习生，超长训练时长引监管关注",
      excerpt: "某大型娱乐公司练习生管理制度遭曝光，未成年练习生权益受到关注。",
      image: "https://readdy.ai/api/search-image?query=Empty%20dance%20training%20room%20late%20at%20night%2C%20dim%20emergency%20lighting%2C%20exhausted%20atmosphere%2C%20clock%20showing%20late%20hour%20on%20wall%2C%20abandoned%20water%20bottles%20on%20floor%2C%20serious%20social%20issue%20theme%2C%20documentary%20style&width=800&height=600&seq=cat-idol-03&orientation=landscape",
      date: "2026-06-17",
      views: 112000,
      isNew: true,
    },
    {
      slug: "girl-group-member-depression",
      title: "女团成员自曝曾因网暴抑郁，公司不作为遭粉丝声讨",
      excerpt: "一位当红女团成员在社交平台发文，透露自己曾因网络暴力患上抑郁症。",
      image: "https://readdy.ai/api/search-image?query=Single%20spotlight%20on%20empty%20stage%20with%20microphone%20stand%2C%20emotional%20performance%20atmosphere%2C%20mental%20health%20awareness%20theme%2C%20dark%20surroundings%20with%20warm%20central%20light%2C%20vulnerable%20artistic%20mood%2C%20powerful%20symbolic%20composition&width=800&height=600&seq=cat-idol-04&orientation=landscape",
      date: "2026-06-16",
      views: 178000,
      isHot: true,
    },
  ],
  "esports-gossip": [
    {
      slug: "esports-team-internal-fight",
      title: "电竞豪门内讧升级，王牌选手与教练训练赛当场对骂",
      excerpt: "某知名电竞战队训练赛录音流出，核心选手与教练发生激烈争吵。",
      image: "https://readdy.ai/api/search-image?query=Professional%20esports%20gaming%20arena%20with%20RGB%20lighting%2C%20competitive%20gaming%20setup%2C%20championship%20stage%2C%20dramatic%20blue%20and%20pink%20neon%20atmosphere%2C%20gaming%20monitors%20and%20keyboards%2C%20spectator%20crowd%20energy%2C%20futuristic%20venue&width=800&height=600&seq=cat-esp-01&orientation=landscape",
      date: "2026-06-25",
      views: 92000,
      isNew: true,
      isHot: true,
    },
    {
      slug: "pro-player-transfer-drama",
      title: "天价转会费刷新纪录，明星选手跳槽引发粉丝大战",
      excerpt: "某顶级电竞选手以创纪录的转会费加盟新东家，新老粉丝激烈对战。",
      image: "https://readdy.ai/api/search-image?query=Esports%20player%20jersey%20exchange%20ceremony%2C%20dramatic%20stadium%20lighting%2C%20competitive%20gaming%20transfer%20theme%2C%20blue%20and%20orange%20contrast%20colors%2C%20professional%20esports%20atmosphere%2C%20championship%20venue&width=800&height=600&seq=cat-esp-02&orientation=landscape",
      date: "2026-06-23",
      views: 78000,
    },
    {
      slug: "streamer-cheating-scandal",
      title: "知名电竞主播被指使用外挂，直播录像成关键证据",
      excerpt: "一位拥有三百万粉丝的游戏主播被质疑在直播中使用作弊软件。",
      image: "https://readdy.ai/api/search-image?query=Gaming%20setup%20with%20keyboard%20and%20mouse%20under%20suspicious%20red%20glow%2C%20cheating%20accusation%20theme%2C%20dark%20room%20atmosphere%2C%20dramatic%20shadows%2C%20competitive%20gaming%20controversy%2C%20intense%20mood%2C%20investigation%20aesthetic&width=800&height=600&seq=cat-esp-03&orientation=landscape",
      date: "2026-06-21",
      views: 115000,
      isHot: true,
    },
    {
      slug: "esports-organization-bankruptcy",
      title: "知名电竞俱乐部被曝资金链断裂，选手工资拖欠三个月",
      excerpt: "某老牌电竞俱乐部陷入严重财务危机，多名选手在社交平台讨薪。",
      image: "https://readdy.ai/api/search-image?query=Empty%20esports%20team%20gaming%20house%20with%20packed%20boxes%2C%20abandoned%20gaming%20peripherals%2C%20moving%20out%20atmosphere%2C%20dim%20natural%20light%20through%20windows%2C%20melancholic%20mood%2C%20end%20of%20an%20era%20feeling%2C%20documentary%20photography&width=800&height=600&seq=cat-esp-04&orientation=landscape",
      date: "2026-06-20",
      views: 83000,
    },
    {
      slug: "game-company-scandal",
      title: "游戏公司高管潜规则女主播，聊天记录流出引行业地震",
      excerpt: "某知名游戏公司高管与多位女主播的不当聊天记录在网络上曝光。",
      image: "https://readdy.ai/api/search-image?query=Corporate%20office%20desk%20with%20smartphone%20displaying%20message%20notifications%2C%20dramatic%20lighting%20through%20blinds%2C%20scandal%20atmosphere%2C%20serious%20business%20setting%2C%20shadow%20and%20light%20contrast%2C%20investigative%20journalism%20mood&width=800&height=600&seq=cat-esp-05&orientation=landscape",
      date: "2026-06-19",
      views: 136000,
      isHot: true,
    },
    {
      slug: "world-championship-accusation",
      title: "世界赛对手质疑中国队作弊，官方调查结果即将公布",
      excerpt: "国际电竞大赛上，某外国战队公开质疑中国队的设备存在违规嫌疑。",
      image: "https://readdy.ai/api/search-image?query=International%20esports%20championship%20trophy%20on%20pedestal%20under%20dramatic%20spotlight%2C%20competitive%20gaming%20arena%20atmosphere%2C%20tension%20and%20controversy%20theme%2C%20grand%20stage%20with%20national%20flags%2C%20high%20stakes%20mood&width=800&height=600&seq=cat-esp-06&orientation=landscape",
      date: "2026-06-18",
      views: 102000,
    },
  ],
};